const noop = () => {};
export const noopPromise = () => Promise.resolve(new Response());
export default noop;
